import React from 'react';
import { UserLiteData } from '../../../api/ApiTypes';
import { AvatarStrip } from '../../common/AvatarStrip';
import { useTaskUserQuery } from './TaskQueries';

export type TasksUserFilterProps = {
    workspaceId: string,
    selected: UserLiteData[],
    onSelect: (next: UserLiteData[]) => void,
};

export const TasksUserFilter = ({ workspaceId, selected, onSelect }: TasksUserFilterProps) => {

    const { data: items } = useTaskUserQuery({
        workspaceId,
    });

    if (!items?.length) return null;
    return <AvatarStrip {...{ items, selected, onSelect }} />;
};
